/**
 * A join code as a link somebody can tap (backlog item 89).
 *
 * `/join/CODE` on this site's own origin. A path rather than a query string because it is what
 * a person reads in a WhatsApp message, and Caddy (and `e2e/support/server.js`) already serve
 * `index.html` for any path that is not a file, so nothing on the server had to change.
 * `launchParams` reads it back.
 *
 * Built from `window.location.origin` rather than a configured address, so a link made in
 * development points at development and one made on gafferpicks.com points there.
 */
export function joinLinkFor(code) {
  return `${window.location.origin}/join/${encodeURIComponent(code)}`;
}

/**
 * The message an invite sends, link last so WhatsApp turns it into a preview card.
 *
 * It says what will actually happen on the other end, because the server decides that and it
 * changes once a game or league is under way.
 */
export function inviteMessage({ kind, name, code, straightIn }) {
  const what = kind === 'league' ? 'my mini-league' : 'my game';
  const next = straightIn
    ? "Tap the link and you'll go straight in."
    : kind === 'league'
      ? "It's already started, so the manager will need to wave you through."
      : "It's just rolled over, so the manager will need to let you in.";
  return `Join ${what} "${name}" on Gaffer Picks.\n${next}\n${joinLinkFor(code)}`;
}

/** WhatsApp's own share address: opens the app (or WhatsApp Web) with the text ready to send. */
export function whatsAppUrl(text) {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

/**
 * Pull a join code out of a path, or null. Only a code-shaped segment counts, so a mistyped or
 * doctored address opens the home page rather than a join box full of rubbish.
 */
export function joinCodeFromPath(path) {
  const match = /^\/join\/([A-Za-z0-9]{4,8})\/?$/.exec(path || '');
  return match ? match[1].toUpperCase() : null;
}
